export enum GroupDisplayName {
    None,
    Name,
    UniqueName,
    AbsoluteName
}